import { Descriptions } from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import useNotification from '../../../hooks/useNotification';
import {
  IAward,
  IAwardModifyReq,
  IAwardReq,
} from '../../../models/award.model';
import Button from '../../Button';
import Radio from '../../Radio';

interface IProps {
  data?: IAward | undefined;
  submit: (data: IAwardReq | IAwardModifyReq) => void;
}

const AwardEditor: FC<IProps> = ({ data, submit }) => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const { infoNotification } = useNotification();

  const [awardCode, setAwardCode] = useState('');
  const [name, setName] = useState('');
  const [descriptionKor, setDescriptionKor] = useState('');
  const [descriptionEng, setDescriptionEng] = useState('');
  const [useYN, setUseYN] = useState<'Y' | 'N'>('Y');

  useEffect(() => {
    if (data) {
      setAwardCode(data.awardCode);
      setName(data.name);
      setDescriptionKor(data.descriptionKor);
      setDescriptionEng(data.descriptionEng);
      setUseYN(data.useYN);
    }
  }, [data]);

  const onSubmit = () => {
    if (!awardCode) {
      return infoNotification(t('program.award.message1'));
    }
    if (!name) {
      return infoNotification(t('program.award.message2'));
    }
    if (!descriptionKor) {
      return infoNotification(t('program.award.message3'));
    }
    if (!descriptionEng) {
      return infoNotification(t('program.award.message4'));
    }

    if (data) {
      const body: IAwardModifyReq = {
        name,
        localeCode: data.localeCode,
        descriptionKor,
        descriptionEng,
        useYN,
      };
      submit(body);
    } else {
      const body: IAwardReq = {
        awardCode,
        name,
        descriptionKor,
        descriptionEng,
        useYN,
      };
      submit(body);
    }
  };

  return (
    <div className="comm-table__area rowType">
      <Descriptions
        bordered
        size="small"
        column={1}
        labelStyle={{ width: '25%' }}
      >
        <Descriptions.Item label="* CODE">
          <input
            type="text"
            className="form-control input-text"
            value={awardCode}
            disabled={Boolean(data)}
            onChange={(e) => setAwardCode(e.target.value)}
          />
        </Descriptions.Item>
        <Descriptions.Item label={`* ${t('program.award.column1')}`}>
          <input
            type="text"
            className="form-control input-text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Descriptions.Item>
        <Descriptions.Item label="* Description (KO)">
          <input
            type="text"
            className="form-control input-text"
            value={descriptionKor}
            onChange={(e) => setDescriptionKor(e.target.value)}
          />
        </Descriptions.Item>
        <Descriptions.Item label="* Description (EN)">
          <input
            type="text"
            className="form-control input-text"
            value={descriptionEng}
            onChange={(e) => setDescriptionEng(e.target.value)}
          />
        </Descriptions.Item>
        <Descriptions.Item label={t('program.award.column4')}>
          <Radio
            checked={useYN === 'Y'}
            onChange={() => setUseYN('Y')}
            text={t('common.option.yes')}
          />
          <Radio
            className="ml-4"
            checked={useYN === 'N'}
            onChange={() => setUseYN('N')}
            text={t('common.option.no')}
          />
        </Descriptions.Item>
      </Descriptions>
      <div className="comm-bx__between">
        <div className="comm-btn__area">
          <Button
            className="btn-basic gray-line"
            onClick={() => history.push('/program/award')}
            text={t('common.button.list')}
          />
        </div>
        <div className="comm-btn__area right">
          <Button
            className="btn-basic pink"
            onClick={onSubmit}
            text={t('common.button.save')}
            writeAuthYn={writeAuthYn}
          />
        </div>
      </div>
    </div>
  );
};

export default AwardEditor;
